'use strict';

var _defaults = require('babel-runtime/helpers/defaults')['default'];

var _interopExportWildcard = require('babel-runtime/helpers/interop-export-wildcard')['default'];

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _bem = require('./bem');

_defaults(exports, _interopExportWildcard(_bem, _defaults));

var _makeClass = require('./makeClass');

_defaults(exports, _interopExportWildcard(_makeClass, _defaults));

var sizes = ["xsmall", "small", "medium", "large", "xlarge", "super"];
exports.sizes = sizes;
var sizeAlias = ["xs", "sm", "md", "lg", "xl", "sp"];
exports.sizeAlias = sizeAlias;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-blazecss/lib/utils/index.js
 ** module id = 15
 ** module chunks = 0
 **/